// Insurance management (/employee-insurance) and the insurance form. The Excel file stays Turkish.
const insurance = {
  page: {
    title: 'Insurance Management',
    subtitle: 'Employees’ personal accident, complementary health and malpractice insurance, and their BES status.',
  },
  actions: {
    add: 'Add Insurance',
    excel: 'Download Table',
    excelHint: 'Download every insurance record as Excel',
  },
  stats: {
    total: 'Total Policies',
    totalShort: 'Total',
    withBES: 'With BES',
    withBESShort: 'BES',
    expiring: 'Ending Soon',
    expiringShort: 'Ending',
    totalCost: 'Total Cost',
    totalCostShort: 'Cost',
    share: '{{percent}}% of all records',
  },
  toolbar: {
    search: 'Search by employee name…',
    searchShort: 'Search employees…',
    expiring: 'Ending soon',
    expiringHint: 'Records with any policy ending within a month',
    bes: 'With BES',
    besHint: 'Only employees with BES',
  },
  types: {
    accidentInsurance: 'Personal Accident Insurance',
    complementaryHealth: 'Complementary Health Insurance',
    malpractice: 'Malpractice Insurance',
  },
  typesShort: {
    accidentInsurance: 'Accident',
    complementaryHealth: 'Health',
    malpractice: 'Malpractice',
  },
  columns: {
    employeeName: 'Employee',
    hasBES: 'BES',
    accidentStart: 'Accident Start',
    accidentEnd: 'Accident End',
    healthStart: 'Complementary Health Start',
    healthEnd: 'Complementary Health End',
    malpracticeStart: 'Malpractice Start',
    malpracticeEnd: 'Malpractice End',
    cost: 'Cost',
  },
  bes: {
    yes: 'Yes',
    no: 'No',
    badge: 'BES: {{value}}',
  },
  state: {
    expired: 'Expired',
    today: 'Ends today',
    soon: '{{days}} days left',
    ok: 'Valid',
  },
  table: {
    listLabel: 'Insurance list',
    empty: 'No insurance records found',
    rangeOf: 'of {{total}} records',
    ofTotal: 'out of {{total}} records',
    jump: 'Go to page',
  },
  panel: {
    label: 'Selected insurance',
    heading: 'Insurance',
    edit: 'Edit',
    delete: 'Delete',
    policies: 'Policies',
    noPeriod: 'No dates entered',
    costPerPerson: 'Cost per person',
    total: 'Total cost',
  },
  form: {
    newTitle: 'Add Insurance',
    editTitle: 'Edit Insurance',
    subtitle: 'BES status, policy periods and costs per person',
    employee: 'Employee',
    employeePlaceholder: 'Choose an employee',
    noEmployees: 'No active employee without insurance',
    employeeHint: 'Only active employees without an insurance record are listed.',
    bes: 'BES',
    yes: 'Yes',
    no: 'No',
    start: 'Start date',
    end: 'End date',
    cost: 'Cost per person (₺)',
    total: 'Total cost (₺)',
    totalAuto: 'Calculated from the costs per person.',
    totalManual: 'No cost per person is entered, so you can enter the total yourself.',
    cancel: 'Cancel',
    save: 'Save',
    update: 'Update',
    saving: 'Saving…',
    errors: {
      employee: 'Please choose an employee',
      cost: 'The cost must be a number',
    },
  },
  delete: {
    title: 'Delete Insurance',
    message: 'Are you sure you want to delete the insurance record of {{name}}? This can’t be undone.',
    confirm: 'Yes, delete',
    cancel: 'Cancel',
  },
  toast: {
    loadError: 'The insurance records could not be loaded',
    employeesError: 'The employees could not be loaded',
    expiring_one: '{{count}} policy record ends within a month!',
    expiring_other: '{{count}} policy records end within a month!',
    deleted: 'Insurance deleted',
    deleteError: 'The insurance could not be deleted',
    excelDone: 'Excel file downloaded',
    formErrors: 'Please fix the errors in the form',
    added: 'Insurance added',
    updated: 'Insurance updated',
    saveError: 'The insurance could not be saved',
    pageJumpInvalid: 'Please enter a page number between 1 and {{max}}.',
  },
};

export default insurance;
